"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react")); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//

/**
 * Reusable logo which can be used across the Common Ground projects.
 */


var CGLogo = function CGLogo(_ref) {
  var props = (0, _extends2["default"])({}, _ref);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 282 282",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#FFBC2C",
    cx: "141",
    cy: "141",
    r: "141"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M120 163.955c7.03 0 12.78 5.724 12.78 12.723 0 2.972-1.062 5.724-3.195 8.057C118.507 195.972 103.594 200 85.705 200 51.413 200 25 172.43 25 138.5S52.053 77 86.777 77c15.124 0 29.397 4.666 40.684 13.78 3.195 2.542 5.539 6.79 5.539 11.027 0 7.419-5.97 13.361-13.421 13.361-3.405 0-6.39-1.057-8.944-3.39-6.6-4.457-15.765-6.79-24.068-6.79-18.319 0-31.74 15.694-31.74 34.14 0 18.446 14.693 34.988 31.95 34.988 10.867 0 16.186-.429 26.412-7.847a11.116 11.116 0 016.81-2.314z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M174.815 139.148c0 18.446 14.687 34.988 31.937 34.988 8.52 0 12.985 0 19.592-3.39V155.26h-10.862c-7.028 0-12.565-5.514-12.565-12.513 0-7 5.537-12.723 12.565-12.723h28.953c7.029 0 12.565 5.723 12.565 12.723v46.444c0 5.723-4.255 9.751-9.581 9.751-4.255 0-7.028-3.18-9.371-6.79l-.64-1.057c-9.161 6.79-18.953 8.904-31.728 8.904-34.28 0-60.68-27.57-60.68-61.5S172.041 77 206.752 77c15.117 0 29.384 4.666 40.667 13.78 3.194 2.542 5.536 6.79 5.536 11.027 0 7.419-5.967 13.361-13.415 13.361-3.404 0-6.388-1.057-8.94-3.39-6.598-4.457-15.759-6.79-24.059-6.79-18.31.02-31.726 15.714-31.726 34.16z",
    fill: "#474E57",
    fillRule: "nonzero"
  })));
};

var _default = CGLogo;
exports["default"] = _default;